import React from "react";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import Spacer from "components/Spacer";
import styles from "./index.module.scss";

interface DetailLayoutHeaderProps {
    title: string;
    extra?: React.ReactNode;
    children?: React.ReactNode;
}

export default function DetailLayoutHeader({
    title,
    extra,
    children
}: DetailLayoutHeaderProps) {
    const history = useHistory();

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>
                <div>
                    <Tooltip title={title} placement="bottomLeft">
                        <span>{title}</span>
                    </Tooltip>

                    <Button
                        className={styles.back}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </div>
                {children}
            </h1>

            <Spacer />

            {extra}
        </div>
    );
}
